import { Link } from "react-router-dom";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const SECONDARY = "var(--secondary, #26a79a)";

/*
import { useEffect, useMemo, useRef, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Paginations from "../../components/Common/Pagination";
import Spinners from "../../components/Common/Spinner";
import { useGetWorkerBookings } from "../../api/booking";
import BookingAgreementSignModal from "./components/BookingAgreementSignModal";
import dayjs from "dayjs";
*/

function WorkerBookings({ t }) {
  document.title = t("workerAssignmentsPageTitle", "My Assignments | Worker");

  /*
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filter, setFilter] = useState("");
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [signTarget, setSignTarget] = useState(null);

  const { mutate, data, isLoading, isPending, error } = useGetWorkerBookings();
  const loading = isLoading || isPending;

  const lastFetchKeyRef = useRef("");
  const fetchKey = JSON.stringify({ page, limit, filter, search });
  const triggerFetch = () =>
    mutate({
      page,
      limit,
      filter: filter || undefined,
      search: search.trim() || undefined,
    });

  useEffect(() => {
    if (lastFetchKeyRef.current === fetchKey) return;
    lastFetchKeyRef.current = fetchKey;
    triggerFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchKey]);

  const payload = data?.data ?? data;
  const requests = payload?.requests ?? [];
  const total = payload?.total ?? 0;

  const closeSignModal = () => setSignTarget(null);

  const canShowSignAgreement = (request) =>
    request?.markAsConfirmedByAdmin === true &&
    Boolean(request?.agreementPdf) &&
    request?.isAgreementSubmitted === false;

  const columns = useMemo(
    () => [
      {
        header: t("workerAssignmentsColBookingId", "Booking ID"),
        accessorKey: "booking.slug",
        enableColumnFilter: false,
        cell: (info) => {
          const request = info.row.original;
          return (
            <Link to={`/my-assignment/${request.slug}`} className="text-primary fw-medium">
              {info.getValue() || "-"}
            </Link>
          );
        }
      },
      {
        header: t("workerAssignmentsColRole", "Role"),
        accessorKey: "role.title",
        enableColumnFilter: false,
        cell: (info) => {
          const request = info.row.original;
          return request.role?.title || "-";
        }
      },
      {
        header: t("workerAssignmentsColLocation", "Location"),
        accessorKey: "booking.location.siteName",
        enableColumnFilter: false,
        cell: (info) => {
          const request = info.row.original;
          return request.booking?.location?.siteName || "-";
        }
      },
      {
        header: t("workerAssignmentsColDates", "Dates"),
        accessorKey: "dates",
        enableColumnFilter: false,
        cell: (info) => {
          const dates = info.getValue() || [];
          if (dates.length === 0) return "-";
          return (
            <div className="d-flex flex-wrap gap-1">
              {dates.slice(0, 3).map((date, idx) => (
                <Badge key={idx} className="bg-primary">
                  {dayjs(date).format("DD MMM")}
                </Badge>
              ))}
              {dates.length > 3 && <Badge className="bg-secondary">+{dates.length - 3} {t("workerAssignmentsMoreDates", "more")}</Badge>}
            </div>
          );
        }
      },
      {
        header: t("workerAssignmentsColShiftTime", "Shift Time"),
        accessorKey: "shift.startTime",
        enableColumnFilter: false,
        cell: (info) => {
          const request = info.row.original;
          const shift = request.shift;
          if (!shift) return "-";
          return `${shift.startTime || "-"} - ${shift.endTime || "-"}`;
        }
      },
      {
        header: t("workerAssignmentsColExpiresAt", "Expires At"),
        accessorKey: "expiresAt",
        enableColumnFilter: false,
        cell: (info) => {
          const expiresAt = info.getValue();
          if (!expiresAt) return "-";
          const isExpired = dayjs(expiresAt).isBefore(dayjs());
          return (
            <div>
              <div>{dayjs(expiresAt).format("DD MMM YYYY, HH:mm")}</div>
              {isExpired && <Badge className="bg-danger mt-1">{t("workerAssignmentsExpired", "Expired")}</Badge>}
            </div>
          );
        }
      },
      {
        header: t("workerAssignmentsColClient", "Client"),
        accessorKey: "booking.createdBy.fullName",
        enableColumnFilter: false,
        cell: (info) => {
          const request = info.row.original;
          return request.booking?.createdBy?.fullName || "-";
        }
      },
      {
        header: t("workerAssignmentsColCreatedDate", "Created Date"),
        accessorKey: "createdAt",
        enableColumnFilter: false,
        cell: (info) => (info.getValue() ? dayjs(info.getValue()).format("DD MMM YYYY") : "-")
      },
      {
        header: t("workerAssignmentsColAction", "Action"),
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps) => {
          const request = cellProps.row.original;
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li>
                <Link
                  to={`/my-assignment/${request.slug}`}
                  className="btn btn-sm btn-soft-info"
                >
                  {t("workerAssignmentsView", "View")} <i className="mdi mdi-eye-outline" />
                </Link>
              </li>
              {canShowSignAgreement(request) && (
                <li>
                  <Button
                    type="button"
                    color="primary"
                    size="sm"
                    className="btn btn-sm btn-soft-primary"
                    onClick={() =>
                      setSignTarget({
                        requestSlug: request.slug,
                        agreementPdf: request.agreementPdf,
                        pdfAxis: request.pdfAxis ?? null,
                      })
                    }
                  >
                    {t("workerAssignmentsSignAgreement", "Sign Agreement")}
                  </Button>
                </li>
              )}
            </ul>
          );
        }
      }
    ],
    [t]
  );
  */

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={t("workerMenuMyAssignments", "My Assignments")}
          breadcrumbItem={t("workerMenuMyAssignments", "My Assignments")}
        />

        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            <Card className="worker-assignments-empty border-0 shadow-sm">
              <CardBody className="p-4 p-md-5 text-center">
                <div className="worker-assignments-empty__icon mx-auto mb-4">
                  <i className="bx bx-briefcase-alt-2" />
                </div>

                <h4 className="worker-assignments-empty__title mb-4">
                  {t(
                    "workerAssignmentsNoCurrentTitle",
                    "No current assignments"
                  )}
                </h4>

                <div className="d-flex flex-column gap-3 mx-auto mb-4 justify-content-center align-items-center">
                  <p className="worker-assignments-empty__message">
                    {t(
                      "workerAssignmentsBody1",
                      "JobArk is actively working with businesses and partners to create opportunities that match your profile, qualifications, availability and work preferences."
                    )}
                  </p>
                  <p className="worker-assignments-empty__message">
                    {t(
                      "workerAssignmentsBody2",
                      "When suitable opportunities become available, our team will contact eligible workers directly."
                    )}
                  </p>
                  <p className="worker-assignments-empty__message mb-0">
                    {t(
                      "workerAssignmentsBody3",
                      "To maximise your opportunities, please keep your profile, availability and qualifications up to date."
                    )}
                  </p>
                </div>

                <div className="worker-assignments-empty__actions">
                  <Link to="/dashboard" className="btn btn-primary px-4">
                    {t(
                      "workerAssignmentsUpdateAvailability",
                      "Update Availability"
                    )}
                  </Link>
                  <Link
                    to="/user/me"
                    className="btn btn-outline-secondary px-4"
                    style={{ borderColor: SECONDARY, color: SECONDARY }}
                  >
                    {t("workerAssignmentsViewProfile", "View Profile")}
                  </Link>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/*
        <Row className="mb-3 g-2 align-items-center">
          <Col md={4}>
            <Input
              type="text"
              placeholder={t("workerAssignmentsSearchPlaceholder", "Search bookings...")}
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setPage(1);
                  setSearch(searchInput.trim());
                }
              }}
            />
          </Col>

          <Col md={2}>
            <Input
              type="select"
              value={filter}
              onChange={(e) => {
                setFilter(e.target.value);
                setPage(1);
              }}
            >
              <option value="">{t("workerAssignmentsAllStatuses", "All Statuses")}</option>
              <option value="approved">{t("workerAssignmentsStatusApproved", "Approved")}</option>
              <option value="assign">{t("workerAssignmentsStatusAssigned", "Assigned")}</option>
              <option value="rejected">{t("workerAssignmentsStatusRejected", "Rejected")}</option>
              <option value="pending">{t("workerAssignmentsStatusPending", "Pending")}</option>
            </Input>
          </Col>
        </Row>

        <Row className="mb-3 g-2 align-items-center">
          <Col md="auto" className="ms-auto d-flex gap-2 align-items-center">
            <Button
              color="primary"
              onClick={() => {
                setPage(1);
                setSearch(searchInput.trim());
              }}
              disabled={loading}
            >
              <i className="mdi mdi-magnify me-1" />
              {t("workerAssignmentsSearch", "Search")}
            </Button>
            <Button
              color="secondary"
              outline
              onClick={() => {
                setFilter("");
                setSearch("");
                setSearchInput("");
                setLimit(10);
                setPage(1);
              }}
              disabled={loading}
            >
              {t("workerAssignmentsReset", "Reset")}
            </Button>
            <Input
              type="select"
              value={limit}
              onChange={(e) => {
                setLimit(Number(e.target.value));
                setPage(1);
              }}
              style={{ width: "auto", minWidth: "100px" }}
            >
              {[10, 20].map((n) => (
                <option key={n} value={n}>
                  {t("workerAssignmentsShowN", { n, defaultValue: "Show {{n}}" })}
                </option>
              ))}
            </Input>
            <Button
              color="light"
              onClick={triggerFetch}
              disabled={loading}
            >
              <i className="mdi mdi-refresh" />
            </Button>
          </Col>
        </Row>

        <Card>
          <CardBody>
            {loading && requests.length === 0 ? (
              <Spinners setLoading={() => {}} />
            ) : error ? (
              <div className="text-danger">{t("workerAssignmentsLoadFailed", "Failed to load bookings.")}</div>
            ) : (
              <>
                <TableContainer
                  columns={columns}
                  data={requests}
                  isPagination={false}
                  isCustomPageSize={false}
                  isGlobalFilter={false}
                  isJobListGlobalFilter={false}
                  tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-2 border-top"
                  theadClass="table-light"
                  divClassName="table-responsive"
                />

                {total > 0 && (
                  <Paginations
                    total={total}
                    perPageData={limit}
                    currentPage={page}
                    setCurrentPage={setPage}
                    isShowingPageLength
                    paginationDiv="dataTables_paginate paging_simple_numbers pagination-rounded d-flex justify-content-end mt-3"
                    paginationClass="pagination"
                  />
                )}
              </>
            )}
          </CardBody>
        </Card>

        <BookingAgreementSignModal
          isOpen={Boolean(signTarget)}
          toggle={closeSignModal}
          bookingRequestSlug={signTarget?.requestSlug}
          agreementPdf={signTarget?.agreementPdf}
          pdfAxis={signTarget?.pdfAxis}
          onSuccess={triggerFetch}
        />
        */}
      </div>
    </div>
  );
}

export default withTranslation()(WorkerBookings);
